export default [
  { key: 'NO_PREFERENCE', title: 'No preference', name: 'noPreference' },
  { key: 'CHICKEN', title: 'Chicken', name: 'chicken' },
  { key: 'DUCK', title: 'Duck', name: 'duck' },
  { key: 'FISH', title: 'Fish', name: 'fish' },
  { key: 'PLANT', title: 'Plant', name: 'plant' },
  { key: 'INSECT', title: 'Insect', name: 'insect' },
  { key: 'GRAIN_FREE', title: 'GrainFree', name: 'grainFree' },
];
